import React from 'react';
import Filter from '../../Filter/Filter/Filter';

const OffersFilter = ({className,
  defaultLabel,
  name,
  search,
  activeParamsNumber,
  onFilterChange,
  onFilterReset,items, children}) => {
  return (
    <Filter
      className={className}
      defaultLabel={defaultLabel}
      name={name}
      search={search}
      items={items}
      activeParamsNumber={activeParamsNumber}
      onFilterChange={onFilterChange}
      onFilterReset={onFilterReset}
      children={children}
    />
  );
};

export default OffersFilter;